import { api } from './_init'

const withEventIdQuery = (url, eventId) => (eventId ? `${url}?eid=${eventId}` : url)

export const fetchCustomPrompt = async (eventId) => {
  try{
    const result = await api.get(withEventIdQuery('prompts/custom_prompt', eventId))

    if (result.status === 200) {
      return {
        success: true,
        data: result.data,
      }
    } else {
      return {
        success: false,
        error: result.data,
      }
    }
  } catch(error){
    return {
      success: false,
      error: error.message,
    }
  }
}

export const createCustomPrompt = async ({prompt, custom_prompt_enabled}, eventId) => {
  try {
    const result = await api.post(withEventIdQuery('prompts/custom_prompt', eventId), { prompt, custom_prompt_enabled })

    if (result.status === 200 || result.status === 204 || result.status === 201) {
      return {
        success: true,
        data: result.data,
      }
    } else {
      return {
        success: false,
        error: result.data,
      }
    }
  } catch (error) {
    return {
      success: false,
      error: error.message,
    }
  }
}


export const updateCustomPrompt = async ({prompt, custom_prompt_enabled}, eventId) => {
  try {
    const result = await api.put(withEventIdQuery('prompts/custom_prompt', eventId), { prompt, custom_prompt_enabled })

    if (result.status === 200 || result.status === 204 || result.status === 201) {
      return {
        success: true,
        data: result.data,
      }
    } else {
      return {
        success: false,
        error: result.data,
      }
    }
  } catch (error) {
    return {
      success: false,
      error: error.message,
    }
  }

}
